import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const reportedByFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.label_reported_by'),
  type: 'in',
  options: {
    options: [
      {
        label: i18n.t('expenses_v2.list.filters.myself'),
        value: 'me',
      },
      {
        label: i18n.t('expenses_v2.list.filters.other_users'),
        value: 'others',
      },
    ],
  },
})
